module.exports = __webpack_public_path__ + "static/media/1.768a460a.jpg";